import LazyLoad from 'vanilla-lazyload';

function initLazyLoading() {
  window.lazyLoad = new LazyLoad({
    elements_selector: '.lazyload',
  });
}

export default initLazyLoading;
